<template>
    <div class="form-group selectbox-wrapper text" :class="errors.has(name) ? 'error' : ''">
        <label :class="current ? 'label-focus' : ''">{{label}} <span v-if="errors.has(name)" class="errors"> - {{ errors.first(name) }} </span></label>
        <select v-validate="validate"  :name="name"  :value="current" @input="input">
            <option v-for="item in options" :key="item.value" :value="item.value">{{ item.label }}</option>
        </select>
    </div>
</template>

<script>
export default {
    inject: ['$validator'],
    props: ['name', 'label', 'value', 'validate', 'options'],
    data() {
        return {
            current: this.value,
        }
    },
    methods: {
        input(e) {
            this.current = e.target.value;
            this.$emit('input', this.current);
        }
    }
}
</script>

<style lang="scss">
    .selectbox-wrapper {
        display: flex;
        flex-flow: column;

        select {
            height: 40px;
        }

        label {
            top: 0 !important;
            left: 0  !important;
            position: inherit  !important;
        }
    }
</style>
